import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import type { HookResult, Transition, TransitionService } from '@uirouter/angular';

@Injectable({
  providedIn: 'root'
})
export class RouterStatusService {
  readonly onPageTransition: BehaviorSubject<boolean | undefined> = new BehaviorSubject<boolean>(undefined);

  static initHooks(transitionService: TransitionService): void {
    transitionService.onBefore(
      { to: 'page.**' }, (transition: Transition): HookResult | void => {
        const routerStatusService: RouterStatusService = transition.injector().get(RouterStatusService);
        routerStatusService.handlePageTransition(false);
      });
    transitionService.onSuccess(
      { to: 'page.**' }, (transition: Transition): HookResult | void => {
        const routerStatusService: RouterStatusService = transition.injector().get(RouterStatusService);
        if (!routerStatusService.isTransient(transition.to().name)) {
          routerStatusService.handlePageTransition(true);
        }
      });
  }

  isPageTransitionFinished(): boolean | undefined {
    return this.onPageTransition.value;
  }

  isTransient(toState: string): boolean {
    return toState.match(/\*\*/) !== null;
  }

  private handlePageTransition(value: boolean): void {
    this.onPageTransition.next(value);
  }
}
